import { useEffect } from 'react';

/**
 * Takes in a callback to execute on debounce and resize event.
 *
 * @param {function} cb - Callback function to execute on window event specified in eventListener
 * @param {array} deps - Dependencies for the hook (e.g. ref)
 * @param {number} ms - The timeout interval for the debounced function to be called.
*/
// eslint-disable-next-line max-params

var useResize = function useResize(cb) {
  var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var ms = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
  useEffect(function () {
    var timer;

    var debounce = function debounce() {
      clearTimeout(timer);
      timer = setTimeout(cb, ms);
    };

    cb();
    window.addEventListener('resize', debounce);
    return function () {
      window.removeEventListener('resize', debounce);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};

export default useResize;
